import React, { useState, useEffect, useRef } from 'react';
import { useParams, useHistory } from 'react-router-dom';
import { useDispatch } from 'react-redux';

import { showNotification } from 'actions/notification';
import { useGetChannels } from 'actions/chatbot';
import DispositionsTab from './tabs/dispositions';
import KnowledgeBaseTab from './tabs/knowledge-base';
import BotsTab from './tabs/bots';
import ChannelsTab from './tabs/channels';
import TestChatTab from './tabs/test-chat';
import ToolsTab from './tabs/tools';
import { Root, Header, Title, TabBar, Tab, Content } from './styled-comps';

const TABS = [
  { key: 'dispositions', label: 'Dispositions' },
  { key: 'knowledge-base', label: 'Knowledge Base' },
  { key: 'bots', label: 'Bots' },
  { key: 'channels', label: 'Channels' },
  { key: 'tools', label: 'Tools' },
  { key: 'test-chat', label: 'Test Chat' },
];

function ChatbotAdmin() {
  const { tab } = useParams();
  const history = useHistory();
  const dispatch = useDispatch();
  const [botConfig, setBotConfig] = useState('parent_app');
  const [selectedChannel, setSelectedChannel] = useState('');
  const selectedChannelRef = useRef(selectedChannel);

  const activeTab = tab || 'dispositions';

  const { get: getChannels, data: channelsData, error: channelsError } = useGetChannels();

  const channels = Array.isArray(channelsData) ? channelsData : [];

  useEffect(() => {
    getChannels('list');
  }, []);

  useEffect(() => {
    if (channelsError) {
      dispatch(
        showNotification({
          text: 'Failed to fetch channels',
          duration: 5,
          showCloseIcon: true,
        }),
      );
    }
  }, [channelsError, dispatch]);

  useEffect(() => {
    if (Array.isArray(channels) && channels.length && !selectedChannelRef.current) {
      const val = channels[0].id || channels[0].name;
      setSelectedChannel(val);
      selectedChannelRef.current = val;
    }
  }, [channels]);

  const handleTabChange = tabKey => {
    history.push(`/chatbot/${tabKey}`);
  };

  const renderTab = () => {
    switch (activeTab) {
      case 'dispositions':
        return <DispositionsTab channels={channels} />;
      case 'knowledge-base':
        return <KnowledgeBaseTab botConfig={botConfig} />;
      case 'bots':
        return <BotsTab />;
      case 'channels':
        return <ChannelsTab />;
      case 'tools':
        return <ToolsTab />;
      case 'test-chat':
        return (
          <TestChatTab
            botConfig={botConfig}
            channels={channels}
            selectedChannel={selectedChannel}
          />
        );
      default:
        return <DispositionsTab channels={channels} />;
    }
  };

  return (
    <Root>
      <Header>
        <Title>Bot Configuration &amp; Testing</Title>
      </Header>
      <TabBar>
        {TABS.map(t => (
          <Tab
            key={t.key}
            $active={activeTab === t.key}
            onClick={() => handleTabChange(t.key)}
          >
            {t.label}
          </Tab>
        ))}
      </TabBar>
      <Content>{renderTab()}</Content>
    </Root>
  );
}

export default ChatbotAdmin;
